import React, { useState } from 'react'
import { v4 as uuidv4 } from 'uuid'

import { object } from 'prop-types'
import { PrismicRichText } from '@prismicio/react'
import * as Styled from './styles/GridBlock.styles'
import CtaLink from './CtaLink'
import LinkWrapper from './LinkWrapper'
import { DISPLAY_WIDTH } from '../../util/constants'

const GridItem = ({ item }) => (
  <Styled.GridItem>
    <Styled.GridItemColumn>
      {item.image && (
        <LinkWrapper link={item.cta_link}>
          <Styled.Picture>
            {item.image?.thumbnails?.mobile?.url && (
              <source
                media={`(max-width: ${DISPLAY_WIDTH.tabletL - 1}px)`}
                srcSet={item.image?.thumbnails?.mobile?.url}
              />
            )}
            <source
              media={`(min-width: ${DISPLAY_WIDTH.tabletL}px)`}
              srcSet={item.image?.url}
            />
            <img src={item.image?.url} alt={item.image?.alt} />
          </Styled.Picture>
        </LinkWrapper>
      )}
      {item.title && <h2>{item.title?.text ?? ''}</h2>}
      {item.summary && (
        <Styled.Summary>
          <PrismicRichText field={item.summary.richText} />
        </Styled.Summary>
      )}
      {item.cta_link_text && (
        <CtaLink
          text={item.cta_link_text ? item.cta_link_text : ''}
          link={item.cta_link}
          additionalStyles={Styled.additionalCtaStyles}
        />
      )}
    </Styled.GridItemColumn>
  </Styled.GridItem>
)

const GridBlock = ({ data, bottomPaddingAdjustment }) => {
  const [uuid] = useState(uuidv4())
  return (
    <Styled.GridBlock bottomPaddingAdjustment={bottomPaddingAdjustment}>
      <Styled.Grid
        data-columns={
          data.primary.layout_type
            ? `--${data.primary.layout_type.replace(/ /g, '-').toLowerCase()}`
            : ''
        }
      >
        {data.items.map((item, index) => (
          <GridItem key={`${uuid}-${index}`} item={item} />
        ))}
      </Styled.Grid>
    </Styled.GridBlock>
  )
}

GridBlock.propTypes = {
  data: object,
}

export default GridBlock
